import {Template} from "../../../components/template/template.jsx";
import {FaPlus} from "react-icons/fa";
import Button from "../../../components/button/button.jsx";
import LanesList from "./components/lanes-list/lanes-list.jsx";
import useLanesFetch from "./hooks/use-lanes-fetch.js";
import {useEffect, useMemo, useRef, useState} from "react";
import LanesForm from "./components/lanes-form/lanes-form.jsx";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import lanesService from "../../../services/web/lanes-service.js";
import MySwal from "sweetalert2";
import {translateError} from "./utils/lanes-form-utils.js";
import projectUtils from "../../../utils/project-utils.js";
import {toast} from "react-toastify";
import {useSearchParams} from "react-router";

const Lanes = () => {
  const [showModal, setShowModal] = useState(false);
  const [forceInactiveOnCreate, setForceInactiveOnCreate] = useState(false);
  const {maintenanceGroup, laneList, ftpUsers} = useLanesFetch({maintenanceGroup: true, laneList: true, ftpUsers: true});

  const [searchParams] = useSearchParams();
  const laneCode = searchParams.get("code");

  const [id, setId] = useState(laneCode ? laneCode : null);
  const isInitialLoadResolved = useRef(!laneCode);
  const queryClient = useQueryClient();

  const {data = null, isLoading} = useQuery({
    queryFn: () => lanesService.getById(id),
    queryKey: ['laneData', id],
    enabled: !!id,
  });

  const {data: dataInfo = null, isLoading: isLoadingDataInfo} = useQuery({
    queryFn: () => lanesService.getInfoById(id),
    queryKey: ['dataInfo', id],
    enabled: !!id,
  });

  const mutation = useMutation({
    mutationFn: ({method, payload}) =>
    {
      if(method === "create") return lanesService.create(payload);
      else if(method === "update") return lanesService.update(payload)
      else if(method === "delete") return lanesService.delete(payload)
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["laneData"]
      });
      queryClient.invalidateQueries({
        queryKey: ["dataInfo"]
      });
      queryClient.invalidateQueries({
        queryKey: ["laneList"]
      });
      if(variables?.silent) return;

      if(variables.method !== "delete" ){
        toast.success("Salvo com sucesso");
      } else {
        toast.success("Excluído com sucesso");
      }
    },
    onError: (err, variables) => {
      let message = ""
      if(Array.isArray(message)){
        for (message in err.response.data){
          message += translateError(err.response.data, variables.method);
        }
      }
      else {
        message = translateError(err.response.data, variables.method);
      }
      projectUtils.swalErrorMessage( "", message);
    }
  })

  const openModal = async () => {
    try {
      await lanesService.checkLicencing();

      setForceInactiveOnCreate(false);
      setShowModal(true);

    } catch (err) {

      const { isConfirmed } = await MySwal.fire({
        title: "Atenção",
        icon: "warning",
        text: "Não há licença disponível. Deseja continuar?",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: '#063A6C',
        cancelButtonColor: '#c10007',
        reverseButtons: true
      });

      if (!isConfirmed) return;
      setForceInactiveOnCreate(true);
      setShowModal(true);
    }
  };

  const laneData = useMemo(() => {
    if (!data) return null;
    return { ...data, lastPassageInfo: dataInfo };
  }, [data, dataInfo]);

  useEffect(() => {
    if (isInitialLoadResolved.current || !laneCode || !laneData) return;

    setShowModal(true);
    isInitialLoadResolved.current = true;
  }, [laneCode, laneData]);

  return(
    <Template isLoading={isLoading || isLoadingDataInfo || maintenanceGroup.isLoading || laneList.isLoading || ftpUsers.isLoading || mutation.isPending}>
      <Template.Header>
        <Template.Title>
          Câmeras de OCR
        </Template.Title>
        <Button onClick={openModal}>
          <FaPlus/> Adicionar câmera
        </Button>
      </Template.Header>
      <Template.Body>
        <LanesList data={laneList.data} maintenanceGroup={maintenanceGroup.data} setId={setId} setShowModal={setShowModal}/>
        <LanesForm show={showModal}
                   setShow={setShowModal}
                   maintenanceGroup={maintenanceGroup.data}
                   ftpUsers={ftpUsers.data}
                   setId={setId}
                   data={laneData}
                   mutation={mutation}
                   forceInactiveOnCreate={forceInactiveOnCreate}
                   isInitialLoad={isInitialLoadResolved.current}
        />
      </Template.Body>
    </Template>
  )
}

export default Lanes;